// A curated list of well-known verses for random "Verse of the Day" display.
export const VOTD_REFS = [
  "John 3:16", "Psalm 23:1", "Philippians 4:13", "Jeremiah 29:11",
  "Romans 8:28", "Proverbs 3:5-6", "Isaiah 40:31", "Joshua 1:9",
  "Matthew 6:33", "Psalm 46:10", "2 Corinthians 5:17", "Ephesians 2:8-9",
  "1 Corinthians 13:4-7", "Galatians 5:22-23", "Romans 12:2", "Hebrews 11:1",
  "James 1:5", "1 Peter 5:7", "Psalm 27:1", "Matthew 11:28",
  "John 14:6", "Romans 6:23", "Psalm 119:105", "Proverbs 16:3",
  "Isaiah 41:10", "Deuteronomy 31:6", "Psalm 34:8", "Colossians 3:23",
  "Micah 6:8", "Lamentations 3:22-23", "2 Timothy 1:7", "1 John 4:19",
  "Matthew 5:16", "Psalm 37:4", "Proverbs 27:17", "John 1:1",
  "Romans 5:8", "Ephesians 4:32", "Philippians 4:6-7", "Psalm 91:1-2",
];
export function pickRandomVerse() {
  return VOTD_REFS[Math.floor(Math.random() * VOTD_REFS.length)];
}
